/**
 * Предоставляет инструменты для работы со ссылками. Например, скопировать ссылки в буфер обмена.
 *
 * @namespace window
 * @since 5.4.0.1000
 */
(function (global) {
  /**
   * Запомнить в кэше источник ссылок.
   *
   * @method window#setLinksSource
   * @param  {string} sourceId ИД ресурса.
   * @param  {string} sourceType Тип ресурса.
   */
  global.setLinksSource = (sourceId, sourceType) => {
    WA.cache.setItem('sourceID', sourceId);
    WA.cache.setItem('sourceType', sourceType);
  }

  /**
   * Скопировать cсылки в буфер.
   *
   * @method window#CopyLinks
   * @param  {object} [contextMenuCopyObj] Объект, для которого было вызвано контекстное меню
   */
  global.CopyLinks = (contextMenuCopyObj) => {
    setLinksSource(null, null);

    ShowTopSpinner();
    let links = getSelectedLinks(contextMenuCopyObj);

    Core.clipboard.copyLinksToClipboard(links).done((copiedLinksCount) => {
      HideTopSpinner(L('COPIED_LINKS', copiedLinksCount), 2000);
    }).fail((completeMsg) => {
      HideTopSpinner(completeMsg, 2000);
    });
  }

  /**
   * Вырезать ссылки.
   *
   * @method window#CutLinks
   * @param  {object} [contextMenuCopyObj] Объект, для которого было вызвано контекстное меню
   */
  global.CutLinks = (contextMenuCopyObj) => {
    ShowTopSpinner();

    let folderId = getCurrentFolderId();

    //если находимся не в папке, то вместо вырезания просто копируем
    if (folderId === null) {
      setLinksSource(null, null);
    } else {
      setLinksSource(folderId, 'F');
    }

    let links = getSelectedLinks(contextMenuCopyObj);

    Core.clipboard.copyLinksToClipboard(links).done((copiedLinksCount) => {
      HideTopSpinner(L('CUT_LINKS', copiedLinksCount), 2000);
    }).fail((completeMsg) => {
      HideTopSpinner(completeMsg, 2000);
    });
  }

  /**
   * Возвращает массив ссылок, которые отмечены как выбранные.
   *
   * @param {object} [contextMenuObj]  объект из которого было вызвано контекстное меню
   * @return {Array<object>} массив ссылок вида {ID:..., Type:..., CompCode:..., Description}
   */
  function getSelectedLinks(contextMenuObj) {
    let links = [];

    if (!!contextMenuObj) {
      // если мы в проводнике или справочнике, значит происходит копирование через контекстное меню
      if (WA.getLocation() === 'explorer' || WA.getLocation() === 'referencerecords') {
        links = takeLinkFromContextMenu(contextMenuObj);
      } else {
        //иначе мы в карточке Документа/ЗЗУ/Записи справочника
        links = takeLinkFromCard(contextMenuObj, WA.getLocation() === 'documentpreview');
      }

    } else {
      // выделены все объекты
      if (isAllRecordsInFolderSelected()) {
        const jObjectContents = $('.object_contents.auto_load');
        if (jObjectContents.length) {
          let componentName = jObjectContents.data('component')
          if (componentName === 'FolderContents' || componentName === 'SearchContents') {
            let params = {
              UserFilterText: WA.CR.objectList.getLikeFilter(),
              UserFilterRequisites: WA.CR.objectList.getlikeFilterRequisites(),
            };
            let serviceUrl;
            if (componentName === 'FolderContents') {
              serviceUrl = '/Folder.asmx/ContentAsHRefs'
              const folderId = GetParamInURL('ID', location.href);
              params.FolderID = folderId;
              params.PredefinedFilter = WA.CR.objectList.getPredefinedFilter();

            } else {
              serviceUrl = '/Session.asmx/GetSearchContentLinks';
              let url = new WA.URL();
              params.SearchName = url.getParam('searchname');
              params.SearchID = jObjectContents.data('uid') || '';
              params.Mode = url.getParam('mode');
              params.ObjectType = url.getParam('objtype');
            }
            CallServiceSync(
              serviceUrl,
              params,
              (res) => {
                links = _takeLinksFromServiceResponse(res);
              }
            );
          }
        }
      }
      //если список пустой, добавим выделенные
      if (!links.length) {
        links = takeLinksFromPage();
      }
    }
    return links;
  }

  /**
  * Получает ссылки, которые вернул веб-сервис и исключает из них невыбранные.
  *
  * @method _takeLinksFromServiceResponse
  * @private
  * @since 5.6.0
  */
  function _takeLinksFromServiceResponse(res) {
    let links = [];
    if (res.Success) {
      let hyperlinks = res.Result;
      let unselectedLinks = WA.CR.objectList.getUnselectedItems();
      let isUnselected = (link) => {
        return unselectedLinks.some((unselectedLink) => {
          let id = +unselectedLink.id;
          return (unselectedLink.kind === convertTypeToKind(link.Type) && link.ID === id);
        })
      }
      hyperlinks.forEach((hyperlink) => {
        let link = {
          Type: hyperlink.Type,
          ID: hyperlink.ID,
          CompCode: hyperlink.ReferenceName || '',
          Description: hyperlink.Description,
        };
        // Исключим невыбранные ссылки                  
        if (!unselectedLinks.length || !isUnselected(link)) {
          links.push(link);
        }
      })
      return links;
    } else {
      HideTopSpinner(L('ERROR_MSG', res.Error), 5000);
      return links;
    }
  }

  /**
   * Получает ссылку из объекта карточки.
   *
   * @param {any} cardObj объект карточки. Может быть как основным объектом карточки, так и вложением.
   * @param {boolean} opt_isGettingNameFromObj признак, что наименование необходимо брать из карточки объекта
   * @return {object} ссылка в формате для агента вида {ID:..., Type:..., CompCode:..., Description}
   */
  function takeLinkFromCard(cardObj, opt_isGettingNameFromObj) {
    //Тут нужно понять, мы копируем сам объект карточки или его вложение
    //Объект с вложением имеет tr, так мы его и опознаем
    // Кроме предпросмотра, в котором объект тоже имеет tr, поэтому добавлен доп. параметр opt_isGettingNameFromObj
    return [
      {
        ID: cardObj.id,
        Type: cardObj.type[0],
        CompCode: !!cardObj.refcode ? cardObj.refcode : '',
        Description: ((cardObj.tr && !opt_isGettingNameFromObj) ? cardObj.tr.find('div.objectname').text() : getCardObjectName()).unescapeHtml()
      }
    ];
  }

  function getCardObjectName() {
    switch (WebAccess.getLocation()) {
      case 'job': return WebAccess.Job.Subject;
      case 'task': return WebAccess.Task.Subject;
      case 'doc':
      case 'documentpreview': return WA.Document.Name;
      case 'reference': return `${WebAccess.ReferenceRecord.ReferenceCaption}: ${WebAccess.ReferenceRecord.Name}`;
      default: return '';
    }
  }

  /**
   * Возвращает ссылку при копировании через контекстное меню
   *
   * @param {any} contextMenuCopyObj объект, для которого было вызвано контекстное меню
   * @return {object} ссылка на объект в формате для агента вида {ID:..., Type:..., CompCode:..., Description}
   */
  function takeLinkFromContextMenu(contextMenuCopyObj) {
    let selected = [];
    let items = WA.CR.objectList.getItems();
    selected.push(items[contextMenuCopyObj.id]);
    //если контекстное меню вызвано у папки из дерева папок
    if (selected.length === 1 && typeof selected[0] === 'undefined') {
      selected[0] = contextMenuCopyObj;
      // Если элемент из DOM, то берем имя прямо со страницы, иначе передан узел дерева, и берем информацию из него.
      if (contextMenuCopyObj instanceof jQuery || contextMenuCopyObj instanceof HTMLElement || contextMenuCopyObj.type === 'CurrentFolder') {
        selected[0].name = contextMenuCopyObj.tr.find('.current-folder__name').text();
      } else {
        if (contextMenuCopyObj.node) {
          selected[0].name = contextMenuCopyObj.node.caption;
        }
      }
    }
    return makeLinksFromItems(selected);
  }

  /**
   * Возвращает ссылки помеченные как выбранные с текущей страницы
   *
   * @return {Array<obj>} Массив ссылок вида {ID:..., Type:..., CompCode:..., Description}
   */
  function takeLinksFromPage() {
    let selected = WA.CR.objectList.getSelectedItems();
    return makeLinksFromItems(selected);
  }

  /**
   * Конвертирует API-ссылки в формат для агента.
   *
   * @param {Array<WA.Link>} items Массив ссылок вида {id:..., kind:..., referenceName:..., name:...}
   * @return {Array<obj>} Массив ссылок вида {ID:..., Type:..., CompCode:..., Description}
   */
  function makeLinksFromItems(items) {
    let links = items.map((item) => {
      let desc = item.name;
      if (item.referenceName && WA.getLocation() === 'referencerecords') {
        // Небольшая оптимизация, т.к. для получения описания записи справочника отправляется запрос на сервер, а если выделить много объектов, то будет тормоза и большая нагрузка.
        let refCaption = $('.card-header__label').data('captioned');
        desc = `${refCaption}: ${item.name}`;
      }
      return {
        ID: item.id,
        Type: item.kind[0].toUpperCase(),
        CompCode: item.referenceName || '',
        Description: desc,
      };
    });
    return links;
  }

  /**
  * Конвертирует тип объекта к виду 
  * 
  * @param {string} type Тип объекта
  * @returns {string} Вид объекта
  */
  function convertTypeToKind(type) {
    switch (type.toUpperCase()) {
      case 'E': return 'EDOC';
      case 'F': return 'FOL';
      case 'J': return 'JOB';
      case 'T': return 'TASK';
      case 'R': return 'REF';
    }
    return '';
  }

  /**
   * Конвертирует ссылки из формата агента в Models.Link
   *
   * @param {Array<object>} links массив ссылок вида {ID:..., Type:..., CompCode:..., Description:...}}
   * @returns {Array<Models.Link>} массив ссылок вида {ID:..., Kind:..., CompCode:..., Desc:...}}
   */
  global.convertAgentLinksToLinkModels = (links) => {
    let convertedLinks = [];
    links.forEach((link) => {
      convertedLinks.push({
        Kind: convertTypeToKind(link.Type[0]),
        ID: link.ID,
        CompCode: link.CompCode,
        Desc: link.Description,
      });
    });
    return convertedLinks;
  }

  /**
   * Переводит ссылки из формата Models.Link в формат агента
   *
   * @param {Array<object>} links массив ссылок вида {ID:..., Kind:..., CompCode:..., Desc:...}}
   * @returns {Array<Models.Link>} массив ссылок вида {ID:..., Type:..., CompCode:..., Description:...}}
   */
  global.convertLinkModelsToAgentLinks = (linkModels) => {
    let convertedLinks = [];
    linkModels.forEach((linkModel) => {
      convertedLinks.push({
        Type: linkModel.Kind[0],
        ID: linkModel.ID,
        CompCode: linkModel.CompCode,
        Description: linkModel.Desc,
      });
    });
    return convertedLinks;
  }

  function getCurrentFolderId() {
    if (WebAccess.getLocation() === 'explorer' && GetParamInURL('mode') === '') {
      return GetParamInURL('id');
    }
    return null;
  }

  /**
   * Возвращает признак выделены ли все объекты или нет.
   *
   * @method window#isAllRecordsInFolderSelected
   * @return {boolean}
   */
  global.isAllRecordsInFolderSelected = () => {
    return WA.ObjectListInit.state() === 'resolved' && !!WA.CR.objectList && WA.CR.objectList.isAllItemsSelected();
  }

  /**
   * Вставить cсылки из буфера.
   *
   * @method window#PasteLinks
   * @param destType: Тип приемника ссылок.
   * @param destId: Приемник ссылок.
   * @param callback: Функция обратного вызова для обработанной ссылки.
   */
  global.PasteLinks = (destType, destId, callback) => {
    if (g_ViewOnlyMsg) {
      ShowTopSpinnerResult(g_ViewOnlyMsg, 2000);
      return;
    }

    if (typeof callback === 'undefined') {
      ShowTopSpinner(L('PASTE_LINKS'));
    }
    destType = destType || 'FOLDER';
    destId = destId || getCurrentFolderId();

    let source = {
      SourceID: WA.cache.getItem('sourceID'),
      SourceType: WA.cache.getItem('sourceType'),
    };

    WebAccess.agent.isPluginAvailable('Clipboard').always((isAvailableResponse) => {
      if (isAvailableResponse) {
        WebAccess.agent.clipboard.getLinksFromClipboard().done((links) => {
          if (links.length && typeof links !== 'string') {
            //Вставляем ссылки в папку
            switch (destType) {
              case 'FOLDER':
                pasteLinksToFolder(destId, links, source, callback);
                break;
              case 'EDOCUMENT':
                pasteLinksToBoundDocuments(destId, links, callback);
                break;
            }
          }
          else {
            HideTopSpinner();
          }
        }).fail(() => {
          pasteLinksDefault(destId, destType, source.SourceID, callback);
        });
      } else {
        pasteLinksDefault(destId, destType, source.SourceID, callback);
      }
      setLinksSource(null, null);
    });
  }

  /**
   * Вставить ссылки в папку.
   *
   * @function pasteLinksToFolder
   * @param {number} destId ИД папки назначения.
   * @param {Array<Object>} links Массив ссылок для вставки.
   * @param {Object} [source] Ссылка на источник, откуда были скопированы ссылки.
   * @param {function} callback Функция обратного вызова.
   * @return {Deferred<void>}
   * @see https://api.jquery.com/category/deferred-object/
   */
  function pasteLinksToFolder(destId, links, source, callback) {
    CallService('/Folder.asmx/AddLinks', { FolderID: destId, Links: links }, (res) => {
      if (res.Success) {
        let d = $.Deferred();
        //Если успешно вставили, то удаляем ссылки из источника
        if ((source != null) && (source.SourceID != null) && source.SourceID != WA.current.getID() && source.SourceType === 'F') {
          let params = {
            FolderID: source.SourceID,
            Links: links,
          };
          d = WA.SRV.call('/Folder.asmx/RemoveLinks', params);
        } else {
          d.resolve();
        }

        d.always(() => {
          if (!CheckForLoginPage(res)) {
            if (res.Result != 0) {
              if (typeof callback !== 'undefined') {
                EnableOrDisableCheckAll();
                callback();
              } else {
                // Обновить список и дерево
                WA.CR.objectList.reload().always(() => {
                  EnableOrDisableCheckAll();
                });
                WA.CR.folderTree.updateByFolderID(destId);
                HideTopSpinner(L('PASTED_LINKS', res.Result), 2000);
              }
            } else {
              if (typeof callback === 'undefined')
                HideTopSpinner(L('NOT_LINKS_TO_PASTE'), 2000);
            }
          }
        });
      } else {
        HideTopSpinner(L('ERROR_MSG', res.Error), 5000);
      }
    });
  }

  /**
    * Вставляет ссылки на связанные документы в текущий документ.
    * @function pasteLinksToBoundDocuments
    * @param {number} docID ИД документа назначения.
    * @param {Array<Object>} links Массив ссылок для вставки.
    * @param {function} callback Функция обратного вызова.
    */
  function pasteLinksToBoundDocuments(docID, links, callback) {
    let destLink = {
      id: Number(docID),
      kind: "EDOC",
      compcode: ""
    };

    //Конвертируем ссылки в формат сервиса
    let sourceLinks = [];
    for (let i = 0; i < links.length; i++) {
      sourceLinks[i] = {
        id: Number(links[i].ID),
        kind: links[i].Kind,
        name: ""
      };
    };

    let _afterBinding = (callback) => {
      if (callback instanceof Function) {
        callback();
      } else {
        WA.CR.window.reload();
      }
    }

    WA.SRV.relations.bindObjects(sourceLinks, destLink).done((result) => {
      let boundCount = result.Pasted.length;

      //Показываем уведомление
      var toast = new WA.CMP.NTF.Toast();
      if (boundCount > 0) {
        toast.show(L('BOUND_LINKS', boundCount));
      } else {
        toast.show(L('NOT_LINKS_TO_BIND'));
      }

      //Если удалось связать не все объекты, то покажем модальное окно с указанием причин
      if (result.Unchanged.length > 0) {
        let reasons = '';
        result.Unchanged.forEach((unchanged) => {
          if (reasons !== '') reasons += '<br /><br/>';
          reasons += unchanged.Item2.escapeHtml();
        });
        let messageBox = new WA.CMP.dialogs.MessageBox({ width: 680 });
        messageBox.okButton(() => { _afterBinding(callback) });
        messageBox.bind('crossClose', () => { _afterBinding(callback) });
        messageBox.showWarning(L('WARN_BINDING_FAILED_FOR_REASONS'), reasons);
      } else {
        _afterBinding(callback);
      }
    });
  }

  function pasteLinksDefault(DestID, DestType, SourceID, callback) {
    let params = {
      DestID: DestID,
      DestType: DestType,
      SourceID: SourceID,
    };
    CallService('/Session.asmx/PasteLinks', params, (res) => {
      if (!CheckForLoginPage(res)) {
        if (res.Result != 0) {
          EnableOrDisableCheckAll();
          if (typeof callback != 'undefined')
            callback();
          else {
            if (DestType === 'FOLDER') {
              // Обновить список и дерево
              WA.CR.objectList.reload().always(() => {
                EnableOrDisableCheckAll();
              });
              WA.CR.folderTree.updateByFolderID(DestID);
              HideTopSpinner(L('PASTED_LINKS', res.Result), 2000);
            } else
              $('form:first').submit();
          }
        } else {
          if (typeof callback === 'undefined')
            HideTopSpinner(L('NOT_LINKS_TO_PASTE'), 2000);
        };
      }
    });
  }

  /**
   * Удалить cсылки
   *
   * @method window#DeleteLinks
   * @param {object} extraParams: Дополнительные параметры.
   * @param {array} links: Ссылки.
   * @param {boolean} [needSubmit = false]
   * @param {number} [sourceId = ''] ИД источника ссылок.
   * @param {boolean} [needConfirmDeleting =  true] Признак необходимости подтверждения удаления.
   * @param {function} afterDeleteCallback: Функция обратного вызова для удаленной ссылки.
   * @param {boolean} isFromTree: Признак принадлежности дереву.
   */
  global.DeleteLinks = (extraParams, links, needSubmit = false, sourceId = '', needConfirmDeleting = true, afterDeleteCallback, isFromTree) => {
    if (!isFromTree && g_ViewOnlyMsg != '') {
      ShowTopSpinnerResult(g_ViewOnlyMsg, 2000);
    } else {
      if (extraParams === null) extraParams = '';
      let linksToDelete = [];

      let deleteAll = isAllRecordsInFolderSelected();
      if ((!deleteAll) || (getSourceType() !== 'FOLDER')) {
        linksToDelete = links || GetSelectedID().links;
      } else {
        linksToDelete = [{
          ID: 0,
          Kind: 'ALL',
        }];
      }

      function getSourceType() {
        let src = WA.getLocation();
        switch (src) {
          case 'explorer':
            return 'FOLDER';
          case 'doc':
            return 'EDOCUMENT';
          case 'job':
            return 'JOB';
          case 'task':
            return 'TASK';
          default:
            return 'FOLDER';
        }
      }

      function callDeleteLinksService() {
        ShowTopSpinner(L('DELETE_LINKS'));
        let params = {
          Links: linksToDelete,
          SourceID: (sourceId || GetParamInURL('id')),
          SourceType: getSourceType(),
          UserFilterText: WA.CR.objectList.getLikeFilter(),
          UserFilterRequisites: WA.CR.objectList.getlikeFilterRequisites(),
          PredefinedFilter: WA.CR.objectList.getPredefinedFilter(),
          UnselectedLinks: WA.CR.objectList.getUnselectedItems(),
        };
        CallService('/Session.asmx/DeleteLinksWithFilter', params, (res) => {
          if (res.Success) {
            res = res.Result;
            if (res) {
              if (getSourceType() === 'FOLDER') {
                WA.CR.objectList.reload().done(() => {
                  if (WA.CR.folderTree) {
                    WA.CR.folderTree.updateNodesWithFolder(WA.CR.getID());
                  }
                });
                updateChkAll($('div.object_contents'), $('#chkAll'));
                UpdateCopyPasteIcons();
                HideTopSpinner(L('DELETED_LINKS', res), 2000);
                EnableOrDisableCheckAll();
              } else {
                $('form:first').submit();
              }
              if ($.isFunction(afterDeleteCallback)) {
                afterDeleteCallback();
              }
            } else {
              if (!needSubmit) {
                HideTopSpinner(L('NO_RIGHT_DELETE_LINKS'), 2000);
              }
            }
          } else {
            HideTopSpinner(res.Error, 2000);
          }
        });
      }

      if (linksToDelete.length) {
        if (needConfirmDeleting) {
          ConfirmDelete(deleteAll ? GetRowsCount() : linksToDelete.length).done(() => {
            callDeleteLinksService();
          });
        }
        else {
          callDeleteLinksService();
        }
      }
      else {
        ShowTopSpinnerResult(L('OBJECTS_NOT_SELECTED'), 2000);
      }
    }
  }
})(window);
